import { Box, CircularProgress, Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface BrandStateProps {
  title: string
  description?: string
  tone?: 'empty' | 'loading' | 'error'
  action?: ReactNode
}

export default function BrandState({ title, description, tone = 'empty', action }: BrandStateProps) {
  const isError = tone === 'error'
  const isLoading = tone === 'loading'
  return (
    <Box
      sx={{
        minHeight: 220,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        textAlign: 'center',
        color: isError ? 'error.dark' : 'primary.dark',
      }}
    >
      <Box sx={{ maxWidth: 420 }}>
        <Box
          sx={{
            width: 58,
            height: 58,
            mx: 'auto',
            mb: 1.5,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            color: isError ? 'error.main' : 'secondary.dark',
            bgcolor: isError ? 'rgba(239, 68, 68, 0.08)' : 'rgba(198, 162, 74, 0.14)',
            border: isError ? '1px solid rgba(239, 68, 68, 0.18)' : '1px solid rgba(198, 162, 74, 0.28)',
          }}
        >
          {isLoading ? (
            <CircularProgress size={26} color="inherit" />
          ) : (
            <Box
              component="span"
              sx={{
                width: 18,
                height: 18,
                borderRadius: '50%',
                border: '2px solid currentColor',
                boxShadow: '0 0 0 6px rgba(198, 162, 74, 0.08)',
              }}
            />
          )}
        </Box>
        <Typography sx={{ fontWeight: 900, color: isError ? 'error.dark' : 'primary.dark', mb: 0.4 }}>
          {title}
        </Typography>
        {description ? (
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, lineHeight: 1.7 }}>
            {description}
          </Typography>
        ) : null}
        {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
      </Box>
    </Box>
  )
}
